import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { UserSelectors } from '@state/global/user';

enum BillingFlow {
	CONTACT_ADMIN = 'contact_admin',
	STRIPE_SETUP = 'stripe_setup',
}

@Component({
	selector: 'app-billing-setup',
	templateUrl: './billing-setup.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class BillingSetupComponent implements OnInit {
	@SelectSnapshot(UserSelectors.getCurrentUserIsAdmin) userIsAdmin: boolean;

	public BillingFlow = BillingFlow;
	public billingFlow: BillingFlow;

	constructor() {}

	ngOnInit(): void {
		this.billingFlow = this.userIsAdmin
			? BillingFlow.STRIPE_SETUP
			: BillingFlow.CONTACT_ADMIN;
	}
}
